import * as React from 'react';
import { isEmpty } from 'es-toolkit/compat';

import { safeToNumber } from '@tock/coretypes';
import LazyImage from '../LazyImage';
import clsx from 'clsx';

// The subset of fields we actually need
export interface BusinessForSwitcher {
  id: number;
  name: string;
  // The "city" and "state" fields from the root of this object come from the proto form.
  // The ones inside "location" come from the GraphQL form.
  // This component needs to support both until we've migrated all uses of this component to GraphQL.
  city?: string | null;
  state?: string | null;
  location?: {
    city?: string | null;
    state?: string | null;
  };
  emailLogoUrl?: string | null;
}

interface Props {
  pathname?: string;
  business: BusinessForSwitcher;
  isEngOrHospitality: boolean;
  onClick(business: BusinessForSwitcher): void;
  selected: boolean;
}

export default class BusinessSwitcherItem extends React.PureComponent<Props> {
  handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.onClick(this.props.business);
  };

  render() {
    const { business, pathname, isEngOrHospitality, selected } = this.props;

    const name = isEngOrHospitality ? business.name.replace(/^The /, '') : business.name;
    const city = business.location?.city ?? business.city;
    const state = business.location?.state ?? business.state;

    const showLogo = (business.emailLogoUrl != null) && !isEmpty(business.emailLogoUrl);

    return (
      <a
        className={clsx('BusinessSwitcher-restaurantListItem', { 'is-selected': selected })}
        onClick={this.handleClick}
        href={pathname ? `${pathname}?switchBusinessId=${business.id}` : undefined}
      >
        {showLogo && (
          <LazyImage
            alt={business.name}
            className="BusinessSwitcher-restaurantListItemLogo"
            src={business.emailLogoUrl ?? ''}
          />
        )}

        <div className="BusinessSwitcher-restaurantListItemName">
          {name}
          <div className="BusinessSwitcher-restaurantListItemLocation">
            {city}, {state}
          </div>
        </div>

        <div className="BusinessSwitcher-restaurantListItemId">{safeToNumber(business.id)}</div>
      </a>
    );
  }
}
